// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-587517ea] {\n  height: calc(100% - 80px);\n  margin: 8px;\n}\n.panes[data-v-587517ea] {\n  position: relative;\n}\n.pane[data-v-587517ea] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.pane-hidden[data-v-587517ea] {\n  visibility: hidden;\n}", ""]);
// Exports
module.exports = exports;
